import {PureComponent, createElement, createRef, ReactNode} from 'react';

interface IProps {
    className: string;
    label: string;
    children?: any;
    onBasemapSwitch: (_?: any) => void;
}

export default class BasemapControl extends PureComponent<IProps> {

    _containerRef = createRef();

    _switchBasemap = () => {
        this.props.onBasemapSwitch();
    }

    _renderButton(type: string, label: string, callback: any, children: ReactNode) {
        return createElement('button', {
            key: type,
            className: `mapboxgl-ctrl-icon mapboxgl-ctrl-${type}`,
            type: 'button',
            title: label,
            onClick: callback,
            children,
        });
    }

    render () {
        const {className, label} = this.props;

        return createElement('div', {
            className: `mapboxgl-ctrl mapboxgl-ctrl-group ${className}`,
            ref: this._containerRef
        }, [
            label && this._renderButton('basemap', 'Switch Basemap', this._switchBasemap,
                this.props.children
            ),
        ]);
    }
}
